// PCとSPを切り替えるブレイクポイント
export const breakpoint = 900;
export const containerID = '#c-citizen-st50';
export const assets_path = '/titaniumtechnology50th/phase3/assets/';
export const site_url = {
  'ja': 'https://citizen.jp/',
  'global': 'https://www.citizenwatch-global.com/'
};